import ms from 'ms';
import ky from 'ky';

import * as auth from '@utils/auth';

export default (baseUrl, { apiPathname = 'api/v1', authorizationPrefix = 'Bearer' } = {}) => {
  const dataSource = ky.create({
    prefixUrl: `${baseUrl}/${apiPathname}`,
    hooks: { beforeRequest: [(request) => auth.injectJwtToken(request, { prefix: authorizationPrefix })] },
    timeout: ms('45s'),
  });

  return dataSource;
};
